// Thin React wrapper over the shared vanilla renderer (public/session-analytics.js).
// The analytics object is rendered AS-IS - computed once by the pipeline, never here
// (contract: schemas/session-analytics.schema.json).
import { useEffect, useRef } from 'react';

export default function SessionAnalytics({ analytics, longitudinal, lang }) {
  const ref = useRef(null);

  useEffect(() => {
    const host = ref.current;
    if (!host || !window.LPSAnalytics) return;
    if (longitudinal && longitudinal.length >= 2) {
      window.LPSAnalytics.renderLongitudinal(host, longitudinal, { lang: lang || 'en' });
    } else if (analytics) {
      window.LPSAnalytics.render(host, analytics, { lang: lang || 'en' });
    }
    return () => { if (host) host.innerHTML = ''; };
  }, [analytics, longitudinal, lang]);

  if (!analytics && !(longitudinal && longitudinal.length >= 2)) return null;
  return <div ref={ref} />;
}
